// components/MCaptcha.tsx
import React, { useEffect, useRef } from 'react';

interface MCaptchaProps {
    siteKey: string;
    baseUrl: string;
    onVerify: (token: string) => void;
    lang: string;
}

const MCaptcha = ({ siteKey, baseUrl, onVerify, lang }: MCaptchaProps): React.ReactElement => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const handleMessage = (event: MessageEvent): void => {
            if (event.origin !== baseUrl) return;
            if (event.data?.token) {
                onVerify(event.data.token);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [baseUrl, onVerify]);

    return (
        <iframe
            ref={iframeRef}
            src={`${baseUrl}/widget/?sitekey=${siteKey}&lang=${lang}`}
            title="mCaptcha"
            width="340"
            height="70"
            allow="cross-origin-isolated"
            style={{
                border: 'none',
                marginLeft: -10
            }}
        ></iframe>
    );
};

export default MCaptcha;
